import React from 'react';

export const RMR_SHOP_LINK =
  'https://fsastore.com/?AFID=490026&ParentId=489804&GroupName=TPA&CID=437559&utm_source=rocky+mountain+reserve&utm_medium=tpa+portal+elevate+link&utm_campaign=TPA+Partner';
export interface Option {
  key: string;
  title: string;
  delimiter?: boolean;
  icon?: React.ReactNode;
  options?: Option[];
  dropdownOptions?: Option[];
  url?: string;
  link?: string;
  textStyle?: React.CSSProperties;
  activeBackgroundOnHover?: boolean;
  additionalIcon?: React.ReactNode;
  disabled?: boolean;
  hintComponent?: React.ReactNode;
  isMobileMode?: boolean;
  withTip?: boolean;
  node?: React.ReactNode;
  isNotClickable?: boolean;
  wrapperStyle?: React.CSSProperties;
}
